__webpack_require__.p = "/BatteryStatus/";